// src/components/common/ConfirmDialog.jsx
import React, { useEffect } from 'react';
import { ExclamationTriangleIcon, InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const TYPE_CONFIG = {
    danger: { icon: ExclamationTriangleIcon, iconBg: 'bg-red-100', iconColor: 'text-red-600', btn: 'bg-red-600 hover:bg-red-700 focus:ring-red-500' },
    warning: { icon: ExclamationTriangleIcon, iconBg: 'bg-yellow-100', iconColor: 'text-yellow-600', btn: 'bg-yellow-500 hover:bg-yellow-600 focus:ring-yellow-400' },
    info: { icon: InformationCircleIcon, iconBg: 'bg-blue-100', iconColor: 'text-blue-600', btn: 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500' },
};

const ConfirmDialog = ({
    title,
    message,
    confirmText = 'Conferma',
    cancelText = 'Annulla',
    type = 'danger',
    onConfirm,
    onCancel,
}) => {
    const config = TYPE_CONFIG[type] || TYPE_CONFIG.danger;
    const Icon = config.icon;

    // Chiudi con Escape
    useEffect(() => {
        const handler = (e) => { if (e.key === 'Escape') onCancel?.(); };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [onCancel]);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onCancel} />

            {/* Dialog */}
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
                {/* Header */}
                <div className="px-6 pt-6 pb-4">
                    <div className="flex items-start gap-4">
                        <div className={`w-11 h-11 ${config.iconBg} rounded-xl flex items-center justify-center flex-shrink-0`}>
                            <Icon className={`w-6 h-6 ${config.iconColor}`} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-base font-bold text-gray-900">{title}</h3>
                            <p className="text-sm text-gray-500 mt-1 leading-relaxed">{message}</p>
                        </div>
                        <button
                            onClick={onCancel}
                            className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition flex-shrink-0"
                        >
                            <XMarkIcon className="w-5 h-5" />
                        </button>
                    </div>
                </div>

                {/* Azioni */}
                <div className="px-6 pb-6 flex gap-3 justify-end">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 border border-gray-200 text-gray-700 text-sm font-medium rounded-xl hover:bg-gray-50 transition"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`px-4 py-2 text-white text-sm font-medium rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 transition ${config.btn}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;